export const OpenSeaLogo = () => {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M90 45C90 69.8514 69.8514 90 45 90C20.1486 90 0 69.8514 0 45C0 20.1486 20.1486 0 45 0C69.8566 0 90 20.1486 90 45Z"
        fill="#2081E2"
      />
      <path
        d="M22.2011 46.512L22.3953 46.2069L34.1016 27.8939C34.2726 27.6257 34.6749 27.6535 34.8043 27.9447C36.76 32.3277 38.4475 37.7786 37.6569 41.1721C37.3194 42.5683 36.3948 44.4593 35.3545 46.2069C35.2204 46.4612 35.0725 46.7109 34.9153 46.9513C34.8413 47.0622 34.7165 47.127 34.5824 47.127H22.5432C22.2196 47.127 22.0301 46.7756 22.2011 46.512Z"
        fill="white"
      />
      <path
        d="M74.38 49.9149V52.8137C74.38 52.9801 74.2783 53.1281 74.1304 53.1928C73.2242 53.5812 70.1219 55.0052 68.832 56.799C65.5402 61.3807 63.0251 67.932 57.4031 67.932H33.949C25.6362 67.932 18.9 61.1727 18.9 52.8322V52.564C18.9 52.3421 19.0803 52.1618 19.3023 52.1618H32.377C32.6359 52.1618 32.8255 52.4022 32.8024 52.6565C32.7099 53.5072 32.8671 54.3764 33.2693 55.167C34.0461 56.7435 35.655 57.7283 37.3934 57.7283H43.866V52.675H37.4673C37.1391 52.675 36.9449 52.2959 37.1345 52.0277C37.2038 51.9214 37.2824 51.8104 37.3656 51.6856C37.9713 50.8257 38.8358 49.4895 39.6958 47.9684C40.2829 46.9421 40.8516 45.8463 41.3093 44.746C41.4018 44.5472 41.4758 44.3438 41.5497 44.1449C41.6746 43.7936 41.804 43.4653 41.8965 43.1371C41.9889 42.8597 42.0629 42.5684 42.1369 42.2956C42.3542 41.3617 42.4467 40.3723 42.4467 39.3459C42.4467 38.9437 42.4282 38.523 42.3912 38.1207C42.3727 37.6815 42.3172 37.2423 42.2617 36.8031C42.2247 36.4147 42.1554 36.031 42.0814 35.6288C41.9889 35.0416 41.8595 34.4591 41.7115 33.8719L41.6607 33.65C41.5497 33.2478 41.4573 32.864 41.3278 32.4618C40.9626 31.1996 40.5418 29.9698 40.098 28.8186C39.9362 28.3609 39.7512 27.9217 39.5663 27.4825C39.2935 26.8213 39.0161 26.2203 38.7619 25.6516C38.6324 25.3927 38.5214 25.1569 38.4105 24.9165C38.2857 24.6437 38.1562 24.371 38.0268 24.112C37.9343 23.9132 37.8279 23.7283 37.754 23.5434L36.9634 22.0824C36.8524 21.8836 37.0374 21.6478 37.2546 21.7079L42.2016 23.0487H42.2155C42.2247 23.0487 42.2294 23.0533 42.234 23.0533L42.8859 23.2336L43.6025 23.437L43.866 23.511V20.5706C43.866 19.1512 45.0034 18 46.4089 18C47.1116 18 47.7496 18.2866 48.2073 18.7536C48.665 19.2206 48.9517 19.8586 48.9517 20.5706V24.935L49.4787 25.0829C49.5204 25.0968 49.562 25.1153 49.599 25.143C49.7284 25.2401 49.9133 25.3835 50.1491 25.5591C50.3341 25.7071 50.5329 25.8874 50.7733 26.0723C51.2495 26.4561 51.8181 26.9508 52.4423 27.5194C52.6087 27.6628 52.7706 27.8107 52.9185 27.9587C53.723 28.7076 54.6245 29.5861 55.4845 30.557C55.7249 30.8297 55.9607 31.1071 56.2011 31.3984C56.4415 31.6943 56.6958 31.9856 56.9177 32.2769C57.209 32.6652 57.5233 33.0674 57.7961 33.4882C57.9256 33.687 58.0735 33.8904 58.1984 34.0892C58.5497 34.6209 58.8595 35.1711 59.1554 35.7212C59.2802 35.9755 59.4097 36.2529 59.5206 36.5257C59.8489 37.2608 60.1078 38.0098 60.2742 38.7588C60.3251 38.9206 60.3621 39.0963 60.3806 39.2535V39.2904C60.436 39.5124 60.4545 39.7482 60.473 39.9886C60.547 40.756 60.51 41.5235 60.3436 42.2956C60.2742 42.6239 60.1818 42.9336 60.0708 43.2619C59.9598 43.5763 59.8489 43.9045 59.7056 44.2143C59.4282 44.8569 59.0999 45.4996 58.7115 46.1006C58.5867 46.3225 58.4388 46.5583 58.2908 46.7802C58.129 47.016 57.9626 47.238 57.8146 47.4553C57.6112 47.7327 57.3939 48.0239 57.172 48.2828C56.9732 48.5556 56.7697 48.8284 56.5478 49.0688C56.2381 49.434 55.9422 49.7808 55.6324 50.1137C55.4475 50.331 55.2487 50.5529 55.0452 50.7517C54.8464 50.9736 54.643 51.1724 54.4581 51.3573C54.1483 51.6671 53.8894 51.9075 53.6721 52.1063L53.1635 52.5733C53.0896 52.638 52.9925 52.675 52.8908 52.675H48.9517V57.7283H53.9079C55.0175 57.7283 56.0716 57.3353 56.9223 56.6141C57.2136 56.3598 58.485 55.2594 59.9876 53.5997C60.0384 53.5442 60.1032 53.5026 60.1771 53.4841L73.8668 49.5265C74.1211 49.4525 74.38 49.6467 74.38 49.9149Z"
        fill="white"
      />
    </svg>
  );
};

export const RaribleLogo = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" fill="#FEDA03"></rect>
      <path
        d="M27.6007 19.8536C28.8607 19.5262 29.9817 18.5838 29.9817 16.6889C29.9817 13.5342 27.3031 12.8 23.8706 12.8H10.2V27.0064H15.9539V22.185H22.7793C23.8309 22.185 24.446 22.6016 24.446 23.6334V27.0064H30.2V23.4548C30.2 21.5203 29.1087 20.3 27.6007 19.8536ZM22.8785 18.3556H15.9539V16.9667H22.8785C23.6325 16.9667 24.0888 17.0659 24.0888 17.6612C24.0888 18.2564 23.6325 18.3556 22.8785 18.3556Z"
        fill="black"
      ></path>
    </svg>
  );
};

export const FoundationLogo = () => {
  return (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <rect fill="black" width="100" height="100" />
      <path
        d="M 64.001 50.635 C 64.001 58.909 57.293 65.619 49.018 65.619 C 40.742 65.619 34.034 58.909 34.034 50.635 C 34.034 42.359 40.742 35.651 49.018 35.651 C 57.293 35.651 64.001 42.359 64.001 50.635 Z M 20.305 37.078 C 20.579 36.602 21.266 36.602 21.541 37.078 L 36.833 63.566 C 37.109 64.042 36.765 64.637 36.215 64.637 L 5.629 64.637 C 5.079 64.637 4.736 64.042 5.01 63.566 L 20.305 37.078 Z M 67.389 36.542 C 66.601 36.542 65.962 37.181 65.962 37.969 L 65.962 63.3 C 65.962 64.087 66.601 64.725 67.389 64.725 L 92.719 64.725 C 93.507 64.725 94.145 64.087 94.145 63.3 L 94.145 37.969 C 94.145 37.181 93.507 36.542 92.719 36.542 L 67.389 36.542 Z"
        fill="white"
      />
    </svg>
  );
};

export const BotFrensBlue = () => {
  return (
    <svg
      width="405"
      height="405"
      viewBox="0 0 405 405"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="405" height="405" fill="#085AB9" />
      <path
        d="M179.762 49.1611C179.762 52.6776 179.824 54.0621 179.898 52.239C179.972 50.4158 179.972 47.5388 179.897 45.8455C179.822 44.1522 179.761 45.6447 179.762 49.1611ZM179.579 80.5503L179.832 92.5181L179.8 80.3295L167.599 80.2975L179.579 80.5503ZM245.519 80.4274C247.344 80.5013 250.224 80.5013 251.919 80.4264C253.614 80.3515 252.12 80.2905 248.6 80.2915C245.08 80.2915 243.694 80.3535 245.519 80.4274ZM229.762 99.1104C229.762 102.627 229.824 104.011 229.898 102.188C229.972 100.365 229.972 97.4881 229.897 95.7948C229.822 94.1015 229.761 95.594 229.762 99.1104ZM217.2 117.689L117.4 117.891L117.18 130.479H104.8V142.866H92.4V155.253H80V242.765H92.4V255.152H104.8V267.539H117.2V405H142.4V305.101H154.8V405H292.4V267.539H304.8V130.479H292.42L292.2 117.891L217.62 117.688L217.378 105.104L217.2 117.689ZM279.8 142.666L292.4 142.886V255.132L279.8 255.352L279.579 267.539H129.6V255.152H117.2V142.886L129.8 142.666L130.021 130.479H279.579L279.8 142.666ZM104.536 177.096C104.681 182.076 104.8 193.315 104.8 202.071V217.99H92.4V168.04H104.272L104.536 177.096ZM192 329.876H180V317.888H192V329.876Z"
        fill="white"
      />
      <path
        d="M180 55.3349L167.4 55.5546L167.188 80.1097L179.8 80.3295L180.02 92.9167H192.4V105.304H204.8V117.692H217.2V105.304H229.6V92.9367L242.2 92.7169L242.42 80.1297H254.8V55.3548H242.4V42.9564L217.4 43.1672L217.179 55.3548H204.8V42.9674H180V55.3349Z"
        fill="white"
      />
      <path
        d="M155 205.003L179.508 205.214L179.78 192.721C179.93 185.85 179.996 174.654 179.926 167.841L179.8 155.453L154.794 155.242L155 205.003ZM242.4 205.203H267.2V155.253H242.4V205.203ZM180 229.978H192.421L192.2 217.79L180 217.569V229.978ZM230 229.978H242.421L242.2 217.79L230 217.569V229.978ZM192.4 242.765H229.6V230.377H192.4V242.765Z"
        fill="white"
      />
      <path d="M171 307.688H267V367.627H171V307.688Z" fill="white" />
    </svg>
  );
};

export const NounsLogo = () => {
  return (
    <svg
      width="320"
      height="320"
      viewBox="0 0 320 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="320" height="320" fill="#EFC950" />
      <path d="M177 110H77V126H177V110Z" fill="#F3322C" />
      <path d="M293 110H193V126H293V110Z" fill="#F3322C" />
      <path d="M93 126H77V144H93V126Z" fill="#F3322C" />
      <path d="M127 126H93V144H127V126Z" fill="white" />
      <path d="M160 126H127V144H160V126Z" fill="black" />
      <path d="M177 126H160V144H177V126Z" fill="#F3322C" />
      <path d="M210 126H193V144H210V126Z" fill="#F3322C" />
      <path d="M243 126H210V144H243V126Z" fill="white" />
      <path d="M277 126H243V144H277V126Z" fill="black" />
      <path d="M293 126H277V144H293V126Z" fill="#F3322C" />
      <path d="M93 144H27V160H93V144Z" fill="#F3322C" />
      <path d="M127 144H93V160H127V144Z" fill="white" />
      <path d="M160 144H127V160H160V144Z" fill="black" />
      <path d="M210 144H160V160H210V144Z" fill="#F3322C" />
      <path d="M243 144H210V160H243V144Z" fill="white" />
      <path d="M277 144H243V160H277V144Z" fill="black" />
      <path d="M293 144H277V160H293V144Z" fill="#F3322C" />
      <path d="M43 160H27V176H43V160Z" fill="#F3322C" />
      <path d="M93 160H77V176H93V160Z" fill="#F3322C" />
      <path d="M127 160H93V176H127V160Z" fill="white" />
      <path d="M160 160H127V176H160V160Z" fill="black" />
      <path d="M177 160H160V176H177V160Z" fill="#F3322C" />
      <path d="M210 160H193V176H210V160Z" fill="#F3322C" />
      <path d="M243 160H210V176H243V160Z" fill="white" />
      <path d="M277 160H243V176H277V160Z" fill="black" />
      <path d="M293 160H277V176H293V160Z" fill="#F3322C" />
      <path d="M43 176H27V194H43V176Z" fill="#F3322C" />
      <path d="M93 176H77V194H93V176Z" fill="#F3322C" />
      <path d="M127 176H93V194H127V176Z" fill="white" />
      <path d="M160 176H127V194H160V176Z" fill="black" />
      <path d="M177 176H160V194H177V176Z" fill="#F3322C" />
      <path d="M210 176H193V194H210V176Z" fill="#F3322C" />
      <path d="M243 176H210V194H243V176Z" fill="white" />
      <path d="M277 176H243V194H277V176Z" fill="black" />
      <path d="M293 176H277V194H293V176Z" fill="#F3322C" />
      <path d="M177 194H77V210H177V194Z" fill="#F3322C" />
      <path d="M293 194H193V210H293V194Z" fill="#F3322C" />
    </svg>
  );
};

export const DiscordLogo = () => {
  return (
    <svg
      width="128"
      height="97"
      viewBox="0 0 128 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M107.7 8.07C99.3467 4.24568 90.5282 1.53258 81.4699 0C80.2304 2.21588 79.1088 4.49573 78.1099 6.83C68.461 5.37602 58.6488 5.37602 48.9999 6.83C48.0005 4.49597 46.8789 2.21615 45.6399 0C36.5758 1.54552 27.7515 4.26506 19.3899 8.09C2.7899 32.65 -1.7101 56.6 0.539904 80.21C10.2613 87.3926 21.1423 92.8551 32.7099 96.36C35.3146 92.8568 37.6194 89.1403 39.5999 85.25C35.8382 83.8451 32.2076 82.1117 28.7499 80.07C29.6599 79.41 30.5499 78.73 31.4099 78.07C41.4709 82.8014 52.4519 85.2546 63.5699 85.2546C74.6879 85.2546 85.6689 82.8014 95.7299 78.07C96.5999 78.78 97.4899 79.46 98.3899 80.07C94.9256 82.115 91.2882 83.8517 87.5199 85.26C89.498 89.1485 91.8029 92.8619 94.4099 96.36C105.987 92.8691 116.877 87.4092 126.6 80.22C129.24 52.84 122.09 29.11 107.7 8.07ZM42.4499 65.69C36.1799 65.69 30.9999 60 30.9999 53C30.9999 46 35.9999 40.26 42.4299 40.26C48.8599 40.26 53.9999 46 53.8899 53C53.7799 60 48.8399 65.69 42.4499 65.69ZM84.6899 65.69C78.4099 65.69 73.2499 60 73.2499 53C73.2499 46 78.2499 40.26 84.6899 40.26C91.1299 40.26 96.2299 46 96.1199 53C96.0099 60 91.0799 65.69 84.6899 65.69Z"
        fill="#5865F2"
      />
    </svg>
  );
};

export const BotFrensLogo = () => {
  return (
    <svg
      width="225"
      height="365"
      viewBox="0 0 225 360"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M99.762 6.211C99.762 9.731 99.824 11.117 99.898 9.292C99.972 7.467 99.972 4.587 99.897 2.892C99.822 1.197 99.761 2.691 99.762 6.211ZM99.579 37.632L99.832 49.612L99.8 37.411L87.599 37.379L99.579 37.632ZM165.519 37.509C167.344 37.583 170.224 37.583 171.919 37.508C173.614 37.433 172.12 37.372 168.6 37.373C165.08 37.373 163.694 37.435 165.519 37.509ZM149.762 56.211C149.762 59.731 149.824 61.117 149.898 59.292C149.972 57.467 149.972 54.587 149.897 52.892C149.822 51.197 149.761 52.691 149.762 56.211ZM137.2 74.808L37.4 75.011L37.18 87.611H24.8V100.011H12.4V112.411H0V200.011H12.4V212.411H24.8V224.811H37.2V362.411H62.4V262.411H74.8V362.411H212.4V224.811H224.8V87.611H212.42L212.2 75.011L137.62 74.807L137.378 62.211L137.2 74.808ZM199.8 99.811L212.4 100.031V212.391L199.8 212.611L199.579 224.811H49.6V212.411H37.2V100.031L49.8 99.811L50.021 87.611H199.579L199.8 99.811ZM24.536 134.276C24.681 139.261 24.8 150.511 24.8 159.276V175.211H12.4V125.211H24.272L24.536 134.276ZM112 287.211H100V275.211H112V287.211Z"
        fill="white"
      />
      <path
        d="M100 12.391L87.4 12.611L87.188 37.191L99.8 37.411L100.02 50.011H112.4V62.411H124.8V74.811H137.2V62.411H149.6V50.031L162.2 49.811L162.42 37.211H174.8V12.411H162.4V0L137.4 0.210999L137.179 12.411H124.8V0.0109978H100V12.391Z"
        fill="white"
      />
      <path
        d="M75 162.211L99.508 162.422L99.78 149.917C99.93 143.039 99.996 131.831 99.926 125.011L99.8 112.611L74.794 112.4L75 162.211ZM162.4 162.411H187.2V112.411H162.4V162.411ZM100 187.211H112.421L112.2 175.011L100 174.79V187.211ZM150 187.211H162.421L162.2 175.011L150 174.79V187.211ZM112.4 200.011H149.6V187.611H112.4V200.011Z"
        fill="white"
      />
      <path d="M91 265H187V325H91V265Z" fill="white" />
    </svg>
  );
};

export const MastodonLogo = () => {
  return (
    <svg
      viewBox="-3 -10 80 83.76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.2484 27.0263V48.114H52.8916V27.6475C52.8916 23.3388 51.096 21.1413 47.4437 21.1413C43.4287 21.1413 41.4177 23.7409 41.4177 28.8755V40.0782H33.1111V28.8755C33.1111 23.7409 31.0965 21.1413 27.0815 21.1413C23.4507 21.1413 21.6371 23.3388 21.6371 27.6475V48.114H13.2839V27.0263C13.2839 22.7176 14.384 19.2946 16.5843 16.7572C18.8539 14.2258 21.8311 12.926 25.5264 12.926C29.8036 12.926 33.0357 14.5705 35.1905 17.8559L37.2698 21.346L39.3527 17.8559C41.5074 14.5705 44.7395 12.926 49.0095 12.926C52.7013 12.926 55.6784 14.2258 57.9553 16.7572C60.1531 19.2922 61.2508 22.7152 61.2484 27.0263Z"
        fill="white"
      />
    </svg>
  );
};
